import { MessageSquare } from 'lucide-react'
import { useUnread } from '../../lib/chat.js'

/**
 * The ข้อความ trigger, in the patient header beside สถานะ.
 *
 * It lives HERE — not floating bottom-right, not in the sidebar — because the
 * realistic failure of patient chat is a message about the wrong patient: the
 * front desk keeps four patient tabs open. Sitting in the row that carries the
 * name, HN and allergy chips is what welds the thread to a person.
 *
 * The badge reads the SHARED unread store, so it and the global sidebar badge
 * can never disagree about the same number.
 */
export default function PatientChatButton({ patientId, open, onToggle }) {
  const unread = useUnread()
  const mine = unread.threads.find((t) => String(t.patient_id) === String(patientId))
  const n = Number(mine?.unread) || 0

  return (
    <button
      type="button"
      onClick={onToggle}
      aria-pressed={open}
      title={n ? `ข้อความใหม่ ${n} ข้อความ` : 'ข้อความ (เคาน์เตอร์ ↔ ห้องตรวจ)'}
      className={`relative inline-flex items-center gap-1.5 h-9 px-3 rounded-xl text-[13.5px] font-medium ring-1 transition-colors ${
        open
          ? 'bg-brand-600 text-white ring-brand-600'
          : 'bg-white text-slate-600 ring-slate-200 hover:bg-slate-50 hover:text-slate-900'
      }`}
    >
      <MessageSquare size={15} strokeWidth={2} />
      <span className="hidden sm:inline">ข้อความ</span>
      {n > 0 && !open && (
        <span className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-rose-500 text-white text-[11px] font-bold leading-[18px] text-center tabular-nums ring-2 ring-white">
          {n > 99 ? '99+' : n}
        </span>
      )}
    </button>
  )
}
